import * as React from "react";
import type { PopupPositionsType } from "@skbkontur/react-ui";
import { TooltipStep, TourComponent } from "@skbkontur/react-ui-tour";

import { scrollElementInCenter } from "../../../Engine/utils";
import { getAnchorElementByControlReferenceOrUndefined } from "../../../Engine/Core/ControlDispatcher/ControlReference";
import { HELPINFO_SHOW } from "../../metricsAction";
import { nullElement } from "../../TypingUtils";
import { useMetrics } from "../../Internals/Metrics/MetricsProviderContext";
import { useTourElementsRegistry } from "../../Internals/TourManagement/TourElementsRegistryContext";

import * as styles from "./HelpInfo.styles";
import regionStatHelpImage from "./regionStatHelp.png";

export interface HelpInfoProps {
    content: React.ReactElement;
    controlId: string | void;
    footer?: () => React.ReactElement;
    header: React.ReactElement;
    showRegionalStatImage?: boolean;
    offset: number | undefined;
    positions: PopupPositionsType[];
    setValue: (value: boolean) => void;
    visible: boolean;
}

export function HelpInfo(props: HelpInfoProps): JSX.Element | null {
    const tourElementsRegistry = useTourElementsRegistry();
    const track = useMetrics();

    const getTarget = (): HTMLElement => {
        const controlId = props.controlId;
        const control = controlId ? tourElementsRegistry.getLastControl(controlId) : undefined;
        const element = getAnchorElementByControlReferenceOrUndefined(control);

        if (element != undefined) {
            scrollElementInCenter(element);
            return element;
        }
        // @ts-ignore Косяк в тайпингах для TooltipStep
        return null;
    };

    const handleTooltipStepOpen = () => {
        if (props.controlId != undefined) {
            track(HELPINFO_SHOW, { controlPath: props.controlId });
        }
    };

    if (!props.visible) {
        return nullElement;
    }

    return (
        <TourComponent onClose={() => props.setValue(false)}>
            <TooltipStep
                content={
                    <div>
                        {props.content}
                        {props.showRegionalStatImage && (
                            <img css={styles.regionStatHelpRoot} src={regionStatHelpImage} />
                        )}
                    </div>
                }
                onOpen={handleTooltipStepOpen}
                footer={props.footer ?? (() => <span />)}
                header={props.header}
                offset={props.offset}
                allowedPositions={props.positions}
                anchorElement={getTarget}
            />
        </TourComponent>
    );

    // в библиотеке react-ui-tour до рендера пытается найти target,
    // когда это будет поправлено можно перейти на этот компонент
    // return this.state.tooltipOpened
    //   ? (
    //     <Tooltip
    //       offset={offset}
    //       positions={positions}
    //       targetGetter={this.getTarget}
    //       onClose={this.handleOnClose}
    //     >
    //       <Tooltip.Container>
    //         <Tooltip.Header>{header}</Tooltip.Header>
    //         <Tooltip.Body>
    //           {this.renderContent()}
    //         </Tooltip.Body>
    //       </Tooltip.Container>
    //     </Tooltip>
    //   )
    //   : null
}
